import { LocaleCode } from "../../typings/lang";
import { SaleTranslationsStatus } from "../../typings/translations";
import { TranslationsMixinController } from "./translations-mixin.controller";

export class TranslateButtonController extends TranslationsMixinController {
    public static $inject: string[] = ["$mdDialog", "$scope", "$translate", "toaster"];

    // binded
    public getTranslationStatus: Function;
    public setTranslationStatus: Function;
    public fetchAll: Function;
    public initiatePublish: Function;
    public isPublishDisabled: boolean;
    public isSaving: boolean;
    public resourceId: number;
    public translationsStatus: SaleTranslationsStatus;

    public currentLocale: string;
    public supportedTargetLanguages: LocaleCode[];

    constructor(
        $mdDialog: ng.material.IDialogService,
        $scope,
        $translate: ng.translate.ITranslateService,
        toaster
    ) {
        super($mdDialog, $scope, $translate, toaster);
    }
}
